const API_BASE_URL = {
  local: 'http://localhost:3000/api/v1/',
  dev: 'https://api.cdap-dev.tsbcloud.in/api/v1/',
  test: 'https://api.cdap-test.tsbcloud.in/api/v1/',
  staging: 'https://api.cdap-staging.tsbcloud.in/api/v1/',
  prod: 'https://api.citydata.org.in/api/v1/',
};
const CACHED_API_BASE_URL = {
  local: 'http://localhost:3000/api/v1/',
  dev: 'https://s.cdap-dev.tsbcloud.in/api/v1/',
  test: 'https://s.cdap-test.tsbcloud.in/api/v1/',
  staging: 'https://s.cdap-staging.tsbcloud.in/api/v1/',
  prod: 'https://s.citydata.org.in/api/v1/',
};
const CACHED_API_FILE_URL = {
  local: 'http://localhost:3000/',
  dev: 'https://s.cdap-dev.tsbcloud.in/',
  test: 'https://s.cdap-test.tsbcloud.in/',
  staging: 'https://s.cdap-staging.tsbcloud.in/',
  prod: 'https://s.citydata.org.in/',
};

// Detect environment
// const ENV = process.env.REACT_APP_ENV || 'local'; 
const ENV = process.env.REACT_APP_ENV || 'local'; 

export const BASE_URL = API_BASE_URL[ENV];
export const CACHED_BASE_URL = CACHED_API_BASE_URL[ENV];
export const CACHED_FILE_BASE_URL = CACHED_API_FILE_URL[ENV];
